export default "__VITE_ASSET__c287dcf7__"